import React from 'react';
import {
  Card, Form, Col, Button,
} from 'react-bootstrap';
import 'react-tiny-fab/dist/styles.css';

export default function ButtonsCardEdit({ can, actions }) {
  return (
    <Card className="mb-4">
      <Card.Body className="p-4">
        <Form.Group as={Col}>
          <Button className="me-2" variant="outline-secondary" onClick={actions.onRead}>Отменить</Button>
          <Button className="me-2" variant="outline-secondary" onClick={actions.onRead}>Перейти в режим просмотра</Button>
          {can.Edit && <Button className="me-2" variant="primary" onClick={actions.onEdit}>Сохранить</Button>}
        </Form.Group>
      </Card.Body>
    </Card>
  );
}
